import { useEffect, useRef } from "react";
import { useClientAuth } from "@/contexts/ClientAuthContext";
import { useI18n } from "@/contexts/I18nContext";
import { isValidLocale } from "@/lib/i18n";
import { trpc } from "@/lib/trpc";

export function LanguageSync() {
  const { client } = useClientAuth();
  const { locale, setLocale } = useI18n();
  const prevLocaleRef = useRef(locale);
  const prevClientIdRef = useRef<string | null>(null);

  const saveLanguageMutation = trpc.clientAuth.saveLanguage.useMutation();

  // On login: load language preference from DB
  useEffect(() => {
    if (!client) return;
    if (prevClientIdRef.current === client.clientId) return;
    prevClientIdRef.current = client.clientId;

    if (isValidLocale(client.language)) {
      setLocale(client.language);
      document.documentElement.lang = client.language;
    }
  }, [client?.clientId]);

  // On locale change: save to DB
  useEffect(() => {
    if (locale === prevLocaleRef.current) return;
    prevLocaleRef.current = locale;

    if (client?.clientId) {
      saveLanguageMutation.mutate({ clientId: client.clientId, language: locale });
    }
  }, [locale]);

  return null;
}
